module.exports = __webpack_public_path__ + "img/id.5683206c.svg";